import React, { useState, useEffect, useContext, useCallback, useRef } from 'react'
import styles from './index.module.less'
import context from '../../context'
import jockey from '@/utils/jockey'
import { IShareChannels } from '../../types'
import { getShareChannels, shareInviteRisk } from '@/components/poizon-fission/apis'
import { Toast } from 'antd-mobile'
import { useWithReactFunctionalTrack } from '@du/analytics-sdk'
import { createTrackConfig } from '../../track-config'
import { isInAppV2 } from '@/utils'

export default function Operate(props: { share: 'before' | 'after' }) {
  const { pageId, operate, activityType, lang, local } = useContext(context)
  const [shareChannels, setShareChannels] = useState<IShareChannels>()
  const [riskInfo, setRiskInfo] = useState({ canShareInvite: false, description: '' })
  // const [platformInfo, setPlatformInfo] = useState({ channel: '', deviceId: '' })
  const platformInfo = { channel: '', deviceId: '' }

  // 埋点绑定
  // 使用hook useEffect api ，当ref有值则组件渲染结束，props可挂载并执行$track函数
  const functionalRef = useRef(null)
  const functionalProps = { ...props }

  useWithReactFunctionalTrack({
    functionalRef,
    functionalProps,
    useEffect,
    createTrackConfig,
  })

  useEffect(() => {
    getShareChannels({
      activityType,
      countryCode: local,
      language: lang,
      sharePath: `/poizon/detail/${lang}/${local}/${pageId}?run=outside`,
    }).then(({ code, data }) => {
      if (code !== 200 || !data) {
        return
      }
      const { channels = [] } = data
      const showChannels: number[] = []
      channels.forEach((item) => {
        switch (item) {
          case 'WECHAT':
            showChannels.push(0)
            break
          case 'FACEBOOK':
            showChannels.push(1)
            break
          case 'MESSENGER':
            showChannels.push(2)
            break
          case 'WHATSAPP':
            showChannels.push(3)
            break
          case 'INSTAGRAM':
            showChannels.push(4)
            break
          case 'TWITTER':
            showChannels.push(6)
            break
          case 'LINE':
            showChannels.push(7)
            break
        }
      })
      setShareChannels({
        ...data,
        channelsMap: showChannels,
      })
    })

    try {
      jockey.getPlatformInfoCallback((d) => {
        console.log('.....d', d)
        platformInfo.channel = d.channel
        platformInfo.deviceId = d.deviceId
        // 执行风控检测方法
        checkUserRiskStatus(platformInfo)
      })
      jockey.getPlatformInfo()
    } catch (error) {
      console.error(error)
    }

    // 端外直接执行
    !isInAppV2() && checkUserRiskStatus(platformInfo)
  }, [activityType, lang, local])

  // 处理邀请新用户点击分享功能
  const handleShare = useCallback(async () => {
    const { title, image, shareUrl, channelsMap, description } = shareChannels

    jockey.socialShare({
      title,
      description,
      link: shareUrl,
      imgUrl: image,
      channels: channelsMap,
    })
  }, [shareChannels])

  // 判断用户是否被风控了
  const checkUserRiskStatus = async (platformInfo) => {
    try {
      const response = await shareInviteRisk(
        {
          activityType,
          countryCode: local,
          language: lang,
        },
        { platform: 'h5', channel: platformInfo.channel, deviceId: platformInfo.deviceId }
      )

      if (response.code !== 200 || !response.data) {
        Toast.info(response.msg)
        return
      }

      const { canShareInvite, description } = response.data

      setRiskInfo((preRiskInfo) => ({
        ...preRiskInfo,
        canShareInvite: canShareInvite,
        description: description || '',
      }))
    } catch (error) {
      console.error(error)
    }
  }

  const handleClick = riskInfo.canShareInvite ? handleShare : null

  const inviteClass = `${styles.invite} ${
    riskInfo.canShareInvite ? styles.buttonEnabled : styles.buttonDisabled
  }`

  const buttonText = riskInfo.canShareInvite ? operate[props.share] : riskInfo.description

  return (
    <footer
      ref={functionalRef}
      className={styles.operate}
      onClick={handleClick}
      data-track-exposure="poizon_activity_invite_pageview"
      data-track-click="poizon_activity_invite_click"
    >
      <div className={inviteClass}>{buttonText}</div>
    </footer>
  )
}
